import { render, staticRenderFns } from "./ActivtyTask.vue?vue&type=template&id=0dfd8feb"
import script from "./ActivtyTask.vue?vue&type=script&lang=js"
export * from "./ActivtyTask.vue?vue&type=script&lang=js"
import style0 from "./ActivtyTask.vue?vue&type=style&index=0&id=0dfd8feb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports